import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/shijisun/edu/projects/imui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Input from './index';
import { Playground, Props } from 'docz';
import './style/index.scss';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "input"
    }}>{`Input`}</h1>

    <h2 {...{
      "id": "props--methods"
    }}>{`Props & Methods`}</h2>
    <Props of={Input} mdxType="Props" />
    <h2 {...{
      "id": "sizes"
    }}>{`Sizes`}</h2>
    <Playground __position={1} __code={'<Input placeholder=\"Small size\" size=\"s\" />\n<span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n<Input placeholder=\"Medium size\" />\n<span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n<Input placeholder=\"Large size\" size=\"l\" />\n<span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n<Input placeholder=\"Long size\" size=\"long\" />'} __scope={{
      props,
      DefaultLayout,
      Input,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Input placeholder="Small size" size="s" mdxType="Input" />
    <span style={{
        display: 'inline-block',
        width: '15px'
      }}></span>
    <Input placeholder="Medium size" mdxType="Input" />
    <span style={{
        display: 'inline-block',
        width: '15px'
      }}></span>
    <Input placeholder="Large size" size="l" mdxType="Input" />
    <span style={{
        display: 'inline-block',
        width: '15px'
      }}></span>
    <Input placeholder="Long size" size="long" mdxType="Input" />
    </Playground>
    <h2 {...{
      "id": "textarea"
    }}>{`Textarea`}</h2>
    <Playground __position={2} __code={'<Input placeholder=\"Default Textarea\" type=\"textarea\" />\n<div style={{ height: \'10px\' }}></div>\n<Input placeholder=\"Textarea with Counter\" type=\"textarea\" counter={100} />\n<div style={{ height: \'10px\' }}></div>\n<Input\n  placeholder=\"中文计数，数字和字符两个算一个\"\n  lan=\"ch\"\n  type=\"textarea\"\n  counter={100}\n/>'} __scope={{
      props,
      DefaultLayout,
      Input,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Input placeholder="Default Textarea" type="textarea" mdxType="Input" />
    <div style={{
        height: '10px'
      }}></div>
    <Input placeholder="Textarea with Counter" type="textarea" counter={100} mdxType="Input" />
    <div style={{
        height: '10px'
      }}></div>
    <Input placeholder="中文计数，数字和字符两个算一个" lan="ch" type="textarea" counter={100} mdxType="Input" />
    </Playground>
    <h2 {...{
      "id": "disabled"
    }}>{`Disabled`}</h2>
    <Playground __position={3} __code={'<Input placeholder=\"disabled text\" disabled />\n<div style={{ height: \'10px\' }}></div>\n<Input placeholder=\"disabled textarea\" type=\"textarea\" disabled />'} __scope={{
      props,
      DefaultLayout,
      Input,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Input placeholder="disabled text" disabled mdxType="Input" />
    <div style={{
        height: '10px'
      }}></div>
    <Input placeholder="disabled textarea" type="textarea" disabled mdxType="Input" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      